/* istanbul ignore file */
import { env } from '@/src/config/env'
import { captureException } from '@/src/config/sentry'

/**
 * Throw an error in dev, print an error message in prod
 */
export const throwDevError = (errorMessage: string, options?: ErrorOptions) => {
  if (env.NODE_ENV === 'development') {
    throw new Error(errorMessage, options)
  } else {
    captureException.then((f) => f(`${errorMessage}: options: ${JSON.stringify(options)}`))
    console.error(errorMessage, options)
  }
}
